import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Drawer, Grid } from 'antd';
import useHankoAuth from './hooks/useHankoAuth';
import Sidebar from './components/layout/Sidebar';
import TopNavbar from './components/layout/TopNavbar';
import UpdateNotificationBanner from './components/layout/UpdateNotificationBanner';
import IdentityReadyFab from './components/layout/IdentityReadyFab';
import { NotificationProvider } from './contexts/NotificationContext';
import cpvLabelMapStore from './components/utils/cpvLabelMapStore';

const { useBreakpoint } = Grid;

const AppLayout = ({ children }) => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
    const { i18n } = useTranslation();
    const { callApi } = useHankoAuth();
    const breakpoints = useBreakpoint();
    const isMobile = breakpoints.lg === false;
    const sidebarWidth = isSidebarCollapsed ? 60 : 250;

    // Close drawer when resizing back to desktop
    useEffect(() => {
        if (!isMobile) setIsMobileDrawerOpen(false);
    }, [isMobile]);

    // Pre-load CPV labels globally so they're available on all pages
    // This triggers reload when language changes
    useEffect(() => {
        const loadCpvLabels = async () => {
            try {
                const language = i18n.language;
                const data = await callApi('GET', `/api/cpv-codes?lang=${language}`);
                if (Array.isArray(data)) {
                    cpvLabelMapStore.populateFromTree(data, language);
                }
            } catch (error) {
                console.error('Failed to pre-load CPV labels:', error);
            }
        };

        loadCpvLabels();
    }, [i18n.language, callApi]);

    return (
        <NotificationProvider>
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <TopNavbar onMenuOpen={() => setIsMobileDrawerOpen(true)} isMobile={isMobile} />

            {isMobile && (
                <Drawer
                    open={isMobileDrawerOpen}
                    onClose={() => setIsMobileDrawerOpen(false)}
                    placement="left"
                    width={250}
                    closable={false}
                    styles={{ body: { padding: 0, backgroundColor: '#27343A' } }}
                >
                    <Sidebar
                        isCollapsed={false}
                        toggleSidebar={() => {}}
                        isMobileDrawer
                        onNavigate={() => setIsMobileDrawerOpen(false)}
                    />
                </Drawer>
            )}

            <div style={{ flex: 1, display: 'flex', overflow: 'hidden' }}>
                {!isMobile && (
                    <div
                        style={{
                            width: `${sidebarWidth}px`,
                            transition: 'width 0.3s ease',
                            overflow: 'hidden'
                        }}
                    >
                        <Sidebar isCollapsed={isSidebarCollapsed} toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)} />
                    </div>
                )}
                <div
                    style={{
                        flex: 1,
                        padding: isMobile ? '0' : '1rem',
                        overflowY: 'auto'
                    }}
                >
                    <UpdateNotificationBanner />
                    {children}
                </div>
            </div>
            <IdentityReadyFab />
        </div>
        </NotificationProvider>
    );
};

export default AppLayout;
